function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(variant_id, quantity, index, callback) {
    getCartUpdate(index, quantity, callback)
}

Shopify.removeItem = function(variant_id, index, callback) {
    getCartUpdate(index, 0, callback)
}

function getCartUpdate(line, quantity, callback) {
    const body = JSON.stringify({
        line,
        quantity,
        sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
        return response.text();
    })
    .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
            showWarning('Error : ' + parsedState.errors, warningTime);
            return;
        }

        if ((typeof callback) === 'function') {
            callback(parsedState);
        } else {
            Shopify.onCartUpdate(parsedState);
        }
    })
    .catch((e) => {
        console.error(e);
    })
}

Shopify.addItem = function(variant_id, quantity, $target, callback, input = null) {
    var quantity = quantity || 1;
    let dataForm = 'quantity=' + quantity + '&id=' + variant_id;

    if ($target.closest('form')) {
        const $thisForm = $target.closest('form');
        const $properties = $thisForm.find('[name^="properties"]');
        if ($properties.length) $properties.each((index, element) => {dataForm = `${dataForm}&${$(element).attr('name')}=${$(element).val()}`})
    }

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: dataForm,
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            var message = window.cartStrings.addProductOutQuantity2;
            if (input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            } 
            
            Shopify.onError(XMLHttpRequest, textStatus, message);
            target?.classList.remove('is-loading');
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        !!data.description ? showWarning(data.description) : showWarning(data.message + ': ' + message, warningTime);
    } else {
        showWarning('Error : ' + message, warningTime);
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeCart = false;
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        const $target = event.target
        let el_input = $target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = $target.closest('.product-form')?.querySelector('[data-btn-addtocart]');
        let newVal, checkAvailabel = false;

        const policyArray = document.body.matches('.quickshop-popup-show') ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`],
            currentId = document.body.matches('.quickshop-popup-show') ? this.closest('.productView-options').querySelector('[name="id"]').value : this.input.dataset.cartQuantityId,
            thisVariantStatus = policyArray[currentId];

        buttonAdd?.dataset.available == 'false' || buttonAdd?.dataset.available == undefined ? checkAvailabel = true : checkAvailabel = false;

        if ($target.matches('.plus')) newVal = value + 1;
        else if ($target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal < 0 ) newVal = 1;

        if (newVal > inStockNumber && checkAvailabel && thisVariantStatus == 'deny') {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }

        el_input.value = newVal;

        if (typeof this.changeCart  == 'number') {clearTimeout(this.changeCart)};
        this.changeCart = setTimeout(() => {if ($target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent)}, 350);
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray == undefined ? false : sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue'
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }
    
    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

        if (newVal > inStockNumber && !buttonAdd.matches('.button--pre-untrack')) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }
        
        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

class ProductScroller extends HTMLElement {
    constructor() {
        super();    
        this.container = this.querySelector('[data-drag-container]');
        this.dragParent = this.querySelector('[data-drag-parent]');

        this.initDragToScroll();
    }

    initDragToScroll() {
        const isOverflowing = (wrapper) => {
            return wrapper.clientWidth < wrapper.scrollWidth
        }
        let containerOverflowing = isOverflowing(this.container)

        if (containerOverflowing) {
            this.dragToScroll(this.container)
            return 
        }
        this.dragToScroll(this.dragParent)
    }   
    
    dragToScroll(slider) {
        let mouseDown = false;
        let start;
        let scrollLeft;
        let inactiveTimeout;

        slider.addEventListener('mousedown', (e) => {
            const target = e.target 

            mouseDown = true;
            start = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseup', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });

        slider.addEventListener('mousemove', (e) => {
            if(!mouseDown) return;
            e.preventDefault();

            if (!slider.classList.contains('active')) {
                slider.classList.add('active');
            }

            const x = e.pageX - slider.offsetLeft;
            const walk = (x - start) * 1; 
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.addEventListener('mouseleave', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super() 

        this.imageContainer = this; 
        this.initObserver();
    }   

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        }, 
        {
            threshold: 0.4 
        });
        
        this.observer.observe(this.imageContainer);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    customElements.define('product-scroller', ProductScroller);
    // customElements.define('image-to-flip', ImageToFlip);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options); 
        this.observer.observe(this);
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
    this.loadScrolling();
})

window.onscroll = () => {this.loadScrolling()};

function loadScrolling() {
    document.querySelectorAll('[data-scrolling]').forEach(element => {element.dataset.scrolling == 'vertical' ? this.scrollVertical(element) : this.scrollHorizontal(element)})
}

function scrollVertical(element) {
    const $thisItem = element.closest('.special-banner__item') || element,
        top = $thisItem.getBoundingClientRect().top,
        height = $thisItem.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        coefficient = element.scrollHeight/height,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2;

    if (top - redundant < 0 && top > height*-1) this.scrollTop(element, (top*-1 + redundant)*coefficient)
    else if (top - redundant >= 0) this.scrollTop(element, 0)
    else this.scrollTop(element, element.scrollHeight)
}

function scrollTop(element, scope) {
    element.scrollTo({top: scope, behavior: "smooth"})
}

function scrollHorizontal(element) {
    const $thisFirst = element.querySelector('.scrolling-text__list--1'),
        $thisSecond = element.querySelector('.scrolling-text__list--2');

    if (!$thisFirst) return;
  
    const top = element.getBoundingClientRect().top,
        height = element.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        scrollWidth = $thisFirst.scrollWidth > window.innerWidth ? $thisFirst.scrollWidth - window.innerWidth : 0,
        contentHeight = $thisFirst.getBoundingClientRect().height*2,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2,
        coefficient = scrollWidth/(height/2 + redundant - contentHeight);
    
    let scope = (top*-1 + redundant)*coefficient,
        scope2 = (height/2 - contentHeight + redundant)*coefficient - scope;
    
    if (top - redundant < 0 && top - contentHeight > height*-1/2) {scope = scope*-1; scope2 = scope2*-1}
    else if (top - redundant >= 0) {scope = 0; scope2 = scrollWidth*-1}
    else {scope = scrollWidth*-1; scope2 = 0}
    $thisFirst.scrollWidth <= window.innerWidth ? $thisSecond.style.justifyContent = 'flex-end' : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
    $thisFirst.style.transform = `translateX(${scope}px)`;
    $thisSecond.style.transform = `translateX(${(scope2)}px)`;
}

class SmoothScrollMenu {
    constructor(selector) {
        this.menuItems = document.querySelectorAll(selector);
        this.attachEvents();
        this.hideMenuItemsWithoutSection();
    }

    attachEvents() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== "#") {
                anchor.addEventListener('click', event => this.handleMenuItemClick(event, anchor));
            }
        });
    }

    handleMenuItemClick(event, anchor) {
        event.preventDefault();

        var targetHref = anchor.getAttribute('href');
        var shouldScroll = true;
        const location = window.location.pathname + window.location.hash;

        if (targetHref.includes('/') && location !== targetHref) {
            window.location.href = targetHref;
            shouldScroll = false;
        }

        if (shouldScroll) {
            var targetElement = document.getElementById(anchor.getAttribute('href').split('#')[1]);
            if (targetElement) {
                this.scrollToSection(targetElement);
            }
        }
    }

    scrollToSection(element) {
        this.smoothScrollTo(element);
    }

    smoothScrollTo(element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop
        });
    }

    hideMenuItemsWithoutSection() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            const hash = anchor.getAttribute('href').split('#')[1];
            if (hash !== undefined && hash !== '' && !document.getElementById(hash)) {
                item.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new SmoothScrollMenu('.header__inline-menu .menu-lv-1');
});

// show color vareint only luna products

(function() {
    const targetProduct = '/products/luna-2-seater-swing';
    const selector = '#shopify-section-template--24290797650200__main .product-form__swatch .product-form__label';
    
    function checkURL() {
        const element = document.querySelector(selector);
        if (element) {
            const currentURL = window.location.href;
            const isLunaProduct = currentURL.includes(targetProduct);
            element.style.setProperty('display', isLunaProduct ? 'block' : 'none', 'important');
        }
    }
    
    // Run immediately and on page changes
    checkURL();
    document.addEventListener('DOMContentLoaded', checkURL);
    window.addEventListener('popstate', checkURL);
})();


// light dark yellow blue 


  document.addEventListener("DOMContentLoaded", function () {
    const label = document.querySelector('label[data-variant-id="50464781697304"]');
    if (label) {
      label.style.setProperty("display", "block", "important");
    }
  });


//multiimage and color varient fix code

// Complete Shopify Product Gallery + Color Variations - Fixed Color Variant Issue
// Fixed color variant selection while maintaining conflict protection
(function() {
    'use strict';
    let retryCount = 0;
    function initGallery() {
        const mainGallery = document.querySelector('[data-image-gallery-main]');
        const thumbnails = document.querySelectorAll('.productView-thumbnail');
        const mainImages = document.querySelectorAll('.productView-image');
        
        if (!mainGallery || !thumbnails.length || !mainImages.length) {
            retryCount++;
            console.log('Gallery elements not found, retrying...');
             if (retryCount < 5) { // Stop after 5 tries
            setTimeout(initGallery, 500);
        }
            return false;
        }
        
        // Initialize - show first image, hide others
        mainImages.forEach((image, index) => {
            if (index === 0) {
                image.style.display = 'block';
                image.classList.add('active');
            } else {
                image.style.display = 'none';
                image.classList.remove('active');
            }
        });
        
        // Set first thumbnail as active
        if (thumbnails.length > 0) {
            updateActiveThumbnail(0);
        }
        
        // Add click handlers to thumbnails
        thumbnails.forEach((thumbnail, index) => {
            const thumbnailLink = thumbnail.querySelector('.productView-thumbnail-link');
            
            if (thumbnailLink) {
                thumbnailLink.style.cursor = 'pointer';
                
                thumbnailLink.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    console.log('Thumbnail clicked:', index);
                    
                    // Update main images visibility
                    updateMainImageDisplay(index);
                    
                    // Update active thumbnail
                    updateActiveThumbnail(index);
                    
                    // Update the main image src with thumbnail's large image
                    const largeImageUrl = this.getAttribute('data-image');
                    if (largeImageUrl && mainImages[index]) {
                        const imgElement = mainImages[index].querySelector('img[data-main-image]');
                        if (imgElement) {
                            imgElement.src = largeImageUrl;
                            imgElement.srcset = largeImageUrl;
                        }
                    }
                });
            }
        });
        
        return true;
    }
    
    function initColorVariations() {
        console.log('Initializing color variations...');
        
        // Define areas to exclude from color handling
        const isExcludedArea = (element) => {
            const excludedSelectors = [
                '.header', '.site-header', '.navigation', '.nav', '.menu',
                '.popup', '.modal', '.overlay', '.cart', '.minicart',
                'table', '.table', '.footer', '[data-app]'
            ];
            
            return excludedSelectors.some(selector => {
                try {
                    return element.closest(selector);
                } catch (e) {
                    return false;
                }
            });
        };
        
        // Enhanced color element selection - more comprehensive
        const colorSelectors = [
            // Shopify common patterns
            '.product-form__color-options .color-swatch',
            '.product-form__variants .variant-option',
            '.product-options .color-option',
            '.variant-wrapper .color-variant',
            '.product-variant-color .color-choice',
            '.color-options .color-option',
            '.variant-color-options .variant-option',
            
            // Generic patterns within product areas
            '.product .color-swatch',
            '.product .variant-swatch',
            '.product [data-color]',
            '.product [data-variant-color]',
            '.product [data-value]',
            '.product .pattern',
            '.product-single .color-swatch',
            '.product-single .variant-swatch',
            '.product-form .color-swatch',
            '.product-form .variant-swatch',
            
            // Label-based selections (common in Shopify)
            'label[for*="color"]',
            'label[for*="Color"]',
            
            // Background color elements within product areas
            '.product [style*="background-color"]:not(img)',
            '.product-single [style*="background-color"]:not(img)',
            '.product-form [style*="background-color"]:not(img)'
        ];
        
        // Find all potential color elements
        let allColorElements = [];
        
        colorSelectors.forEach(selector => {
            try {
                const elements = document.querySelectorAll(selector);
                elements.forEach(element => {
                    if (!isExcludedArea(element) && !allColorElements.includes(element)) {
                        allColorElements.push(element);
                    }
                });
            } catch (e) {
                console.warn('Invalid selector:', selector, e);
            }
        });
        
        console.log('Found color elements:', allColorElements.length);
        
        // Process each color element
        allColorElements.forEach((colorElement, index) => {
            // Skip if already processed
            if (colorElement.dataset.colorHandlerAdded) return;
            
            // Double-check exclusion
            if (isExcludedArea(colorElement)) {
                console.log('Skipping excluded element:', colorElement);
                return;
            }
            
            console.log('Processing color element:', colorElement);
            
            // Make it visually interactive
            colorElement.style.cursor = 'pointer';
            colorElement.dataset.colorHandlerAdded = 'true';
            
            // Add the click handler
            colorElement.addEventListener('click', function(e) {
                // Runtime exclusion check
                if (isExcludedArea(this)) {
                    console.log('Runtime exclusion triggered for:', this);
                    return;
                }
                
                e.preventDefault();
                e.stopPropagation();
                
                console.log('Color variant clicked:', this);
                
                // Remove active states from all color elements (only safe ones)
                allColorElements.forEach(el => {
                    if (!isExcludedArea(el)) {
                        el.classList.remove('active', 'selected', 'variant-selected');
                        el.setAttribute('aria-selected', 'false');
                    }
                });
                
                // Add active state to clicked element
                this.classList.add('active', 'selected', 'variant-selected');
                this.setAttribute('aria-selected', 'true');
                
                // Get the color value
                const colorValue = getColorValueFromElement(this);
                console.log('Selected color value:', colorValue);
                
                if (colorValue) {
                    updateProductVariant(colorValue);
                    updateColorSelection(this);
                    changeImageForColor(this, index);
                }
            });
        });
        
        // Handle form inputs separately
        initVariantInputs();
    }
    
    function initVariantInputs() {
        const variantInputSelectors = [
            'input[name*="Color" i]',
            'input[name*="color"]',
            'select[name*="Color" i]',
            'select[name*="color"]',
            'input[name="properties[Color]"]',
            'select[name="properties[Color]"]'
        ];
        
        variantInputSelectors.forEach(selector => {
            try {
                const inputs = document.querySelectorAll(selector);
                inputs.forEach(input => {
                    input.addEventListener('change', function() {
                        console.log('Variant input changed:', this.value);
                        if (typeof window.updateVariant === 'function') {
                            window.updateVariant();
                        }
                    });
                });
            } catch (e) {
                console.warn('Invalid input selector:', selector);
            }
        });
    }
    
    function getColorValueFromElement(colorElement) {
        // Priority order for getting color value
        
        // 1. Check if it's a label with associated radio/checkbox
        if (colorElement.tagName === 'LABEL' && colorElement.getAttribute('for')) {
            const input = document.getElementById(colorElement.getAttribute('for'));
            if (input && input.value) {
                return input.value;
            }
        }
        
        // 2. Check if it contains a radio/checkbox
        const input = colorElement.querySelector('input[type="radio"], input[type="checkbox"]');
        if (input && input.value) {
            return input.value;
        }
        
        // 3. Check parent label
        const parentLabel = colorElement.closest('label');
        if (parentLabel && parentLabel.getAttribute('for')) {
            const associatedInput = document.getElementById(parentLabel.getAttribute('for'));
            if (associatedInput && associatedInput.value) {
                return associatedInput.value;
            }
        }
        
        // 4. Check data attributes
        return colorElement.dataset.color || 
               colorElement.dataset.value || 
               colorElement.dataset.variantColor ||
               colorElement.getAttribute('data-variant-color') ||
               colorElement.getAttribute('title') ||
               colorElement.textContent.trim() ||
               'Unknown';
    }
    
    function changeImageForColor(colorElement, colorIndex) {
        console.log('Changing image for color:', colorElement, 'index:', colorIndex);
        
        const colorValue = getColorValueFromElement(colorElement);
        console.log('Color value:', colorValue);
        
        // Update color name display
        updateColorNameDisplay(colorValue);
        
        // Try to match color to thumbnail
        const thumbnails = document.querySelectorAll('.productView-thumbnail');
        let matchedThumbnailIndex = -1;
        
        // Method 1: Match by filename containing color
        thumbnails.forEach((thumb, index) => {
            const thumbImg = thumb.querySelector('img');
            const thumbLink = thumb.querySelector('.productView-thumbnail-link');
            
            if (thumbImg && thumbLink) {
                const thumbSrc = thumbImg.src.toLowerCase();
                const thumbDataImage = (thumbLink.getAttribute('data-image') || '').toLowerCase();
                const colorFormatted = colorValue.toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^a-z0-9-]/g, '');
                
                if (colorFormatted.length > 2 && 
                    (thumbSrc.includes(colorFormatted) || thumbDataImage.includes(colorFormatted))) {
                    matchedThumbnailIndex = index;
                    console.log('Found matching thumbnail at index:', index);
                    return;
                }
            }
        });
        
        // Method 2: Use color index if available
        if (matchedThumbnailIndex === -1 && thumbnails[colorIndex]) {
            matchedThumbnailIndex = colorIndex;
            console.log('Using color index:', colorIndex);
        }
        
        // Method 3: Try sequential matching
        if (matchedThumbnailIndex === -1) {
            const allColorElements = document.querySelectorAll('.product .color-swatch, .product .variant-swatch, .product [data-color], .product [data-variant-color]');
            const elementIndex = Array.from(allColorElements).indexOf(colorElement);
            if (elementIndex !== -1 && thumbnails[elementIndex]) {
                matchedThumbnailIndex = elementIndex;
                console.log('Using element index:', elementIndex);
            }
        }
        
        // Apply the image change
        if (matchedThumbnailIndex !== -1) {
            updateMainImageDisplay(matchedThumbnailIndex);
            updateActiveThumbnail(matchedThumbnailIndex);
        } else {
            console.log('No matching thumbnail found for color:', colorValue);
        }
        
        // Update form elements
        updateRadioButton(colorValue);
    }
    
    function updateColorNameDisplay(colorValue) {
        const colorNameSelectors = [
            '[data-header-option]',
            '.selected-color',
            '.current-color',
            '.variant-color-name'
        ];
        
        colorNameSelectors.forEach(selector => {
            const element = document.querySelector(selector);
            if (element && colorValue) {
                console.log('Updating color name display to:', colorValue);
                element.textContent = colorValue;
            }
        });
    }
    
    function updateRadioButton(colorValue) {
        // Find and check the correct radio button
        const radioSelectors = [
            `input[name*="Color"][value="${colorValue}"]`,
            `input[name*="color"][value="${colorValue}"]`,
            `input[value="${colorValue}"]`
        ];
        
        radioSelectors.forEach(selector => {
            try {
                const radioButton = document.querySelector(selector);
                if (radioButton) {
                    console.log('Checking radio button for:', colorValue);
                    radioButton.checked = true;
                    radioButton.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } catch (e) {
                console.warn('Radio button selector error:', selector);
            }
        });
    }
    
    function updateProductVariant(colorValue) {
        console.log('Updating product variant to:', colorValue);
        
        // Update various form inputs
        const inputSelectors = [
            `input[name*="Color"][value="${colorValue}"]`,
            `input[name*="color"][value="${colorValue}"]`,
            `option[value="${colorValue}"]`
        ];
        
        inputSelectors.forEach(selector => {
            try {
                const inputs = document.querySelectorAll(selector);
                inputs.forEach(input => {
                    if (input.type === 'radio' || input.type === 'checkbox') {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    } else if (input.tagName === 'OPTION') {
                        input.selected = true;
                        if (input.parentElement) {
                            input.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                });
            } catch (e) {
                console.warn('Variant input error:', selector);
            }
        });
        
        // Trigger Shopify callbacks
        try {
            if (typeof window.selectCallback === 'function') {
                window.selectCallback();
            }
            
            document.dispatchEvent(new CustomEvent('variant:change', {
                detail: { value: colorValue }
            }));
        } catch (e) {
            console.warn('Callback error:', e);
        }
    }
    
    function updateColorSelection(selectedElement) {
        // Visual feedback for selected color
        const productColorElements = document.querySelectorAll([
            '.product .color-swatch',
            '.product .variant-swatch', 
            '.product [data-color]',
            '.product [data-variant-color]'
        ].join(', '));
        
        productColorElements.forEach(el => {
            // Reset styles
            el.style.transform = 'scale(1)';
            el.style.boxShadow = '';
            el.style.outline = '';
        });
        
        // Highlight selected element
        if (selectedElement && selectedElement.closest('.product, .product-form, .product-single')) {
            selectedElement.style.transform = 'scale(1.1)';
            selectedElement.style.boxShadow = '0 0 0 2px #000';
            selectedElement.style.outline = '2px solid #000';
        }
    }
    
    function updateMainImageDisplay(activeIndex) {
        const mainImages = document.querySelectorAll('.productView-image');
        
        console.log('Updating main images, active index:', activeIndex);
        
        mainImages.forEach((image, index) => {
            if (index === activeIndex) {
                console.log('Showing image:', index);
                image.style.display = 'block';
                image.style.opacity = '1';
                image.style.position = 'relative';
                image.style.zIndex = '10';
                image.classList.add('active');
            } else {
                console.log('Hiding image:', index);
                image.style.display = 'none';
                image.style.opacity = '0';
                image.style.position = 'absolute';
                image.style.zIndex = '1';
                image.classList.remove('active');
            }
        });
    }
    
    function updateActiveThumbnail(activeIndex) {
        const thumbnails = document.querySelectorAll('.productView-thumbnail');
        
        thumbnails.forEach((thumbnail, index) => {
            const thumbnailLink = thumbnail.querySelector('.productView-thumbnail-link');
            if (index === activeIndex) {
                thumbnail.classList.add('active', 'selected');
                thumbnail.setAttribute('aria-selected', 'true');
                if (thumbnailLink) {
                    thumbnailLink.style.borderColor = '#000';
                    thumbnailLink.style.opacity = '1';
                }
            } else {
                thumbnail.classList.remove('active', 'selected');
                thumbnail.setAttribute('aria-selected', 'false');
                if (thumbnailLink) {
                    thumbnailLink.style.borderColor = 'transparent';
                    thumbnailLink.style.opacity = '0.7';
                }
            }
        });
    }
    
    // Add CSS styles
    function addStyles() {
        const existingStyle = document.getElementById('gallery-color-fix-styles');
        if (existingStyle) {
            existingStyle.remove();
        }
        
        const style = document.createElement('style');
        style.id = 'gallery-color-fix-styles';
        style.textContent = `
            /* Thumbnail Gallery Styles */
            .productView-thumbnail .productView-thumbnail-link {
                border: 2px solid transparent;
                opacity: 0.7;
                transition: all 0.3s ease;
                display: block;
                cursor: pointer;
            }
            
            .productView-thumbnail.active .productView-thumbnail-link,
            .productView-thumbnail.selected .productView-thumbnail-link {
                border: 2px solid #000 !important;
                opacity: 1 !important;
            }
            
            .productView-thumbnail .productView-thumbnail-link:hover {
                opacity: 1;
                border-color: #666;
            }
            
            .productView-nav[data-image-gallery-main] {
                position: relative;
                overflow: hidden;
            }
            
            .productView-image {
                transition: opacity 0.3s ease;
            }
            
            .productView-image:not(.active) {
                display: none !important;
                opacity: 0 !important;
            }
            
            .productView-image.active {
                display: block !important;
                opacity: 1 !important;
                position: relative !important;
                z-index: 10 !important;
            }
            
            /* Enhanced Color Variation Styles */
            .product .color-swatch,
            .product .variant-swatch,
            .product [data-color],
            .product [data-variant-color],
            .product-single .color-swatch,
            .product-single .variant-swatch,
            .product-form .color-swatch,
            .product-form .variant-swatch,
            label[for*="color" ],
            label[for*="Color" ] {
                cursor: pointer !important;
                transition: all 0.3s ease;
                position: relative;
                display: inline-block;
            }
            
            /* Hover effects */
            .product .color-swatch:hover,
            .product .variant-swatch:hover,
            .product [data-color]:hover,
            .product [data-variant-color]:hover,
            .product-single .color-swatch:hover,
            .product-single .variant-swatch:hover,
            .product-form .color-swatch:hover,
            .product-form .variant-swatch:hover,
            label[for*="color"]:hover,
            label[for*="Color"]:hover {
                transform: scale(1.05);
            }
            
            /* Active/Selected states */
            .product .color-swatch.active,
            .product .color-swatch.selected,
            .product .variant-swatch.active,
            .product .variant-swatch.selected,
            .product [data-color].active,
            .product [data-variant-color].active,
            .product-single .color-swatch.active,
            .product-single .variant-swatch.active,
            .product-form .color-swatch.active,
            .product-form .variant-swatch.active,
            label[for*="color"].active,
            label[for*="Color"].active {
                transform: scale(1.1) !important;
                box-shadow: 0 0 0 2px #000 !important;
                outline: 2px solid #000 !important;
                z-index: 10;
            }
            
            /* Background color elements within product areas */
            .product [style*="background-color"]:not(img),
            .product-single [style*="background-color"]:not(img),
            .product-form [style*="background-color"]:not(img) {
                cursor: pointer !important;
                min-width: 30px;
                min-height: 30px;
                display: inline-block;
                transition: all 0.3s ease;
                border-radius: 4px;
            }
            
            .product [style*="background-color"]:hover:not(img),
            .product-single [style*="background-color"]:hover:not(img),
            .product-form [style*="background-color"]:hover:not(img) {
                transform: scale(1.05);
            }
            
          
            
            /* Mobile responsiveness */
            @media (max-width: 768px) {
                .productView-thumbnail .productView-thumbnail-link {
                    min-height: 60px;
                    min-width: 60px;
                }
                
                .product .color-swatch,
                .product .variant-swatch {
                    min-width: 40px;
                    min-height: 40px;
                    margin: 5px;
                }
                
                .productView-image.active {
                    max-width: 100%;
                    height: auto;
                }
            }
        `;
        document.head.appendChild(style);
    }
    
    // Main initialization
    function init() {
        console.log('Initializing gallery and color variations...');
        addStyles();
        
        const initialize = () => {
            setTimeout(() => {
                initGallery();
                initColorVariations();
            }, 100);
        };
        
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initialize);
        } else {
            initialize();
        }
    }
    
    // Handle Shopify AJAX updates
    if (typeof Shopify !== 'undefined') {
        document.addEventListener('shopify:section:load', function() {
            console.log('Shopify section loaded, reinitializing...');
            setTimeout(() => {
                initGallery();
                initColorVariations();
            }, 300);
        });
    }
    
    // Initialize
    init();
    
})();




// Enhanced jQuery fallback with better conflict protection
if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(function($) {
        console.log('jQuery fallback initialized');
        
        // Gallery fallback
        $(document).on('click', '.productView-thumbnail .productView-thumbnail-link', function(e) {
            e.preventDefault();
            const $thumbnail = $(this).closest('.productView-thumbnail');
            const index = $('.productView-thumbnail').index($thumbnail);
            
            $('.productView-image').hide().removeClass('active');
            $('.productView-image').eq(index).show().addClass('active');
            $('.productView-thumbnail').removeClass('active selected');
            $thumbnail.addClass('active selected');
        });
        
        // Enhanced color variations fallback
        const colorSelector = [
            '.product .color-swatch',
            '.product .variant-swatch',
            '.product [data-color]',
            '.product [data-variant-color]',
            '.product-single .color-swatch',
            '.product-single .variant-swatch',
            '.product-form .color-swatch',
            '.product-form .variant-swatch',
            'label[for*="color"]',
            'label[for*="Color"]',
            '.product [style*="background-color"]:not(img)'
        ].join(', ');
        
        $(document).on('click', colorSelector, function(e) {
            const $this = $(this);
            
            // Safety check for excluded areas
            if ($this.closest('.header, .site-header, .popup, .modal, .overlay, table, .table, .nav, .navigation, .menu, .cart, .minicart, .footer, [data-app]').length) {
                console.log('jQuery: Excluded area clicked, ignoring');
                return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            console.log('jQuery: Color clicked', this);
            
            // Remove active states
            $(colorSelector).removeClass('active selected variant-selected');
            $this.addClass('active selected variant-selected');
            
            // Get color value
            let colorValue = '';
            
            // Check if it's a label
            if ($this.is('label') && $this.attr('for')) {
                const $input = $('#' + $this.attr('for'));
                if ($input.length && $input.val()) {
                    colorValue = $input.val();
                    $input.prop('checked', true).trigger('change');
                }
            }
            
            // Fallback to data attributes
            if (!colorValue) {
                colorValue = $this.data('color') || 
                           $this.data('value') || 
                           $this.data('variant-color') ||
                           $this.attr('title') ||
                           $this.text().trim();
            }
            
            console.log('jQuery: Selected color value:', colorValue);
            
            if (colorValue) {
                // Update color display
                $('[data-header-option], .selected-color, .current-color').text(colorValue);
                
                // Find matching thumbnail
                $('.productView-thumbnail').each(function(index) {
                    const $thumb = $(this);
                    const thumbSrc = ($thumb.find('img').attr('src') || '').toLowerCase();
                    const thumbDataImage = ($thumb.find('.productView-thumbnail-link').attr('data-image') || '').toLowerCase();
                    const colorFormatted = colorValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                    
                    if (colorFormatted.length > 2 && (thumbSrc.includes(colorFormatted) || thumbDataImage.includes(colorFormatted))) {
                        $('.productView-image').hide().removeClass('active');
                        $('.productView-image').eq(index).show().addClass('active');
                        $('.productView-thumbnail').removeClass('active selected');
                        $thumb.addClass('active selected');
                        return false; // Break loop
                    }
                });
            }
        });
    });
}



